import { render, staticRenderFns } from "./PaymentMethodPixMobile.vue?vue&type=template&id=02f34796"
import script from "./PaymentMethodPixMobile.vue?vue&type=script&lang=js"
export * from "./PaymentMethodPixMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports